import React, { useEffect } from 'react';
import MenuLateral from './MenuLateral';

// Gaveta do celular: o mesmo menu lateral do computador, deslizando da esquerda.
// No celular o topo só tem ☰ e o título, então conta, links e Sair ficam aqui.
export default function MobileMenu({
  open, onClose,
  items,        // [{ id, label, emoji }]
  currentId,
  onSelect,
  badges = {},
  userName = 'Usuário',
  userEmail = '',
  logo,
  portal = 'Portal do Consultor',
  mostrarWebmail = false,
  onAccount,
  onLogout,
}) {
  useEffect(() => {
    if (!open) return;
    const orig = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => { document.body.style.overflow = orig; window.removeEventListener('keydown', onKey); };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="gaveta-fundo" onClick={onClose}>
      <aside className="sidebar gaveta" onClick={e => e.stopPropagation()} aria-label="Menu">
        <div className="sidebar-topo">
          <div className="sidebar-marca">
            {logo && <img src={logo} alt="Kzero" className="sidebar-logo" />}
            <small>{portal}</small>
          </div>
          <button className="gaveta-fechar" onClick={onClose} aria-label="Fechar menu">×</button>
        </div>

        <MenuLateral itens={items} atual={currentId} badges={badges} onSelect={(id) => { onSelect(id); onClose(); }} />

        <div className="sidebar-rodape">
          {mostrarWebmail && (
            <a className="sidebar-link" href="https://titan.hostgator.com.br/mail/" target="_blank" rel="noopener noreferrer">✉️ Webmail</a>
          )}
          <a className="sidebar-link" href="https://www.kzerosystem.com.br/login" target="_blank" rel="noopener noreferrer">🔗 KzeroSystem</a>
          <button className="sidebar-conta" onClick={() => { onAccount?.(); onClose(); }}>
            <span className="avatar">{(userName || '?').trim().charAt(0).toUpperCase()}</span>
            <span className="sidebar-conta-texto">
              <b>{userName}</b>
              {userEmail && <small>{userEmail}</small>}
            </span>
          </button>
          <button className="sidebar-sair" onClick={() => { onLogout?.(); onClose(); }}>Sair</button>
        </div>
      </aside>
    </div>
  );
}
